import { Box } from '@chakra-ui/react';
import './index.css';

const Thinking = () => {
  return (
    <Box display="flex" justifyContent="center" mt={1}>
      <Box
        w={4}
        h={4}
        borderRadius="full"
        bg="teal.200"
        mx={1}
        animation="thinking-loading 1s infinite ease-in-out"
      />
      <Box
        w={4}
        h={4}
        borderRadius="full"
        bg="teal.200"
        mx={1}
        animation="thinking-loading 1s infinite ease-in-out 0.25s"
      />
      <Box
        w={4}
        h={4}
        borderRadius="full"
        bg="teal.200"
        mx={1}
        animation="thinking-loading 1s infinite ease-in-out 0.5s"
      />
    </Box>
  );
};

export default Thinking;
